import {
    LoadingSpinner,
    createLoadingSpinner,
    ILoadingSpinnerProperties,
} from '@vfde-brix/ws10/loading-spinner';

/**
 * Returns a Loading Spinner ws10 class mounted on the chosen div.
 */
export const mountLoadingSpinner = (wrapperId: string): LoadingSpinner | null => {
    const wrapperElement = document.getElementById(wrapperId);
    const props: ILoadingSpinnerProperties = {
        optSize: 'medium',
        business: {},
    };

    return wrapperElement && createLoadingSpinner(wrapperElement, props);
};
